var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.16536H10.834V4.16536C10.834 3.94435 10.7462 3.73239 10.5899 3.57611C10.4336 3.41983 10.2217 3.33203 10.0007 3.33203C9.77964 3.33203 9.56768 3.41983 9.4114 3.57611C9.25512 3.73239 9.16732 3.94435 9.16732 4.16536V9.16536H4.16732C3.9463 9.16536 3.73434 9.25316 3.57806 9.40944C3.42178 9.56572 3.33398 9.77768 3.33398 9.9987C3.33398 10.2197 3.42178 10.4317 3.57806 10.588C3.73434 10.7442 3.9463 10.832 4.16732 10.832H9.16732V15.832C9.16732 16.053 9.25512 16.265 9.4114 16.4213C9.56768 16.5776 9.77964 16.6654 10.0007 16.6654C10.2217 16.6654 10.4336 16.5776 10.5899 16.4213C10.7462 16.265 10.834 16.053 10.834 15.832V10.832H15.834C16.055 10.832 16.267 10.7442 16.4232 10.588C16.5795 10.4317 16.6673 10.2197 16.6673 9.9987C16.6673 9.77768 16.5795 9.56572 16.4232 9.40944C16.267 9.25316 16.055 9.16536 15.834 9.16536Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b058187b8b738f0062d788c0f397e1c0.svg";
export { ForwardRef as ReactComponent };